import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { OwnedParking } from '@repo/domain';

const ParkingContext = createContext<OwnedParking | undefined>(undefined);

interface Props {
  parking: OwnedParking;
  children: ReactNode;
}

export function ParkingProvider({ parking, children }: Props) {
  return <ParkingContext value={parking}>{children}</ParkingContext>;
}

export function useParkingContext(): OwnedParking {
  const context = useContext(ParkingContext);
  if (context === undefined) {
    throw new Error('useParkingContext must be used within ParkingProvider');
  }
  return context;
}
